import { forwardRef } from 'react';

import { FadeProps, Fade as MuiFade } from '@mui/material';

export const Fade = forwardRef<HTMLElement, FadeProps>((props, ref) => (
  <MuiFade ref={ref} timeout={{ enter: 250, exit: 250 }} in {...props} />
));
